import moment from 'moment';

export const getSupplierSummaryInfo = ({supplier, t}: SupplierSummaryInfoParams) => {
  const contractDate = supplier.contract_date
    ? moment(supplier.contract_date).format('DD.MM.YYYY')
    : '';
  const contract = supplier.contract_num && contractDate
    ? `${supplier.contract_num} ${t('common__text__from')} ${contractDate}`
    : supplier.contract_num || contractDate;

  return [
    {
      label: t('common__text__name'),
      value: supplier.name,
    },
    {
      label: t('calc__text__main__contractNumberAndDate'),
      value: contract,
    },
    {
      label: t('calc__text__main__address'),
      value: supplier.legal_address,
    },
    {
      label: t('calc__text__main__comments'),
      value: supplier.additional_info,
    },
    {
      label: t('calc__text__main__fullNameOfTheContactPerson'),
      value: supplier.contact_person,
    },
    {
      label: t('common__text__phone'),
      value: supplier.phone,
    },
    {
      label: t('dictionaries__text__transportCompany__addInn'),
      value: supplier.inn,
    },
    {
      label: t('dictionaries__text__transportCompany__addKpp'),
      value: supplier.kpp,
    },
    {
      label: t('dictionaries__text__transportCompany__addOgrn'),
      value: supplier.ogrn,
    },
  ].filter(({value}) => Boolean(value));
};
